import { Link } from '@tanstack/react-router';
import { useTranslation } from '@/i18n';

interface StartModalProps {
  onStart: (level?: number) => void;
}

export function StartModal({ onStart }: StartModalProps) {
  const { t } = useTranslation();

  return (
    <div className="modal-backdrop animate-fade-in p-2 sm:p-4">
      <div className="card p-4 sm:p-8 max-w-lg w-full animate-scale-in max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] overflow-y-auto">
        <div className="flex items-center justify-between mb-4 sm:mb-6">
          <Link 
            to="/" 
            className="px-3 py-1.5 rounded-full bg-border-dark 
                       text-text-secondary hover:text-text-primary hover:bg-border-light
                       transition-colors text-sm font-medium"
          >
            {t.common.back}
          </Link>
          <div className="flex-1" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-text-primary text-center mb-1">
          {t.automationDrop.title}
        </h2>
        <p className="text-ukonnx-green font-semibold text-center text-xs sm:text-sm tracking-wider mb-4 sm:mb-6">
          {t.automationDrop.subtitle}
        </p>

        <p className="text-text-secondary text-center text-sm sm:text-base mb-4 sm:mb-6">
          {t.automationDrop.mission}
        </p>

        <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
          <h3 className="text-ukonnx-green font-semibold text-xs sm:text-sm uppercase tracking-wider">
            {t.automationDrop.howToPlay}
          </h3>

          <div className="flex items-start gap-3 sm:gap-4">
            <span className="text-xl sm:text-2xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center shrink-0
                          bg-ukonnx-green/20 text-ukonnx-green rounded-lg border border-ukonnx-green/20">
              ☑
            </span>
            <div>
              <span className="text-text-primary font-medium text-sm sm:text-base">{t.automationDrop.inst1}</span>
              <span className="text-text-muted text-xs sm:text-sm block">({t.automationDrop.inst1Sub})</span>
            </div>
          </div>

          <div className="flex items-start gap-3 sm:gap-4">
            <span className="text-xl sm:text-2xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center shrink-0
                          bg-accent-red/20 text-accent-red-light rounded-lg border border-accent-red/20">
              ✖
            </span>
            <span className="text-text-primary font-medium text-sm sm:text-base">{t.automationDrop.inst2}</span>
          </div>

          <div className="flex items-start gap-3 sm:gap-4">
            <span className="text-xl sm:text-2xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center shrink-0
                          bg-accent-gold/20 text-accent-gold rounded-lg border border-accent-gold/20">
              ✨
            </span>
            <div>
              <span className="text-text-primary font-medium text-sm sm:text-base">{t.automationDrop.inst3}</span>
              <span className="text-text-muted text-xs sm:text-sm block">({t.automationDrop.inst3Sub})</span>
            </div>
          </div>
        </div>

        <div className="bg-accent-gold/10 border border-accent-gold/30 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
          <h4 className="text-accent-gold font-semibold text-xs sm:text-sm mb-1 sm:mb-2">{t.automationDrop.howToWin}</h4>
          <p className="text-text-secondary text-xs sm:text-sm">
            {t.automationDrop.winText}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
          <button onClick={() => onStart(0)} className="btn-primary flex-1 text-base sm:text-lg py-3 sm:py-4">
            {t.automationDrop.startBtn}
          </button>
          <button 
            onClick={() => {/* TODO: Show highscores */}} 
            className="btn-secondary py-3 sm:py-4"
          >
            {t.automationDrop.highscoreBtn}
          </button>
        </div>
      </div>
    </div>
  );
}
